import { apiClient } from './client';
import { ApiResponse } from '@/types';
import type { FindingSeverity } from './inspections';

export interface VoiceObservation {
  title: string;
  description: string;
  severity: FindingSeverity;
  location?: string;
  recommendation?: string;
}

export interface VoiceReportSection {
  sectionTitle: string;
  itemTitle: string;
  itemDescription: string;
  severity: FindingSeverity;
}

export interface VoiceAnalysis {
  id: string;
  summary: string;
  observations: VoiceObservation[];
  suggestedReportSections: VoiceReportSection[];
  rawTranscript: string;
  inputTokens: number;
  outputTokens: number;
  /** IDs of findings auto-created in the DB — used to delete them if the user discards */
  findingIds?: string[];
}

export interface VoiceAnalyzeParams {
  transcript: string;
  reportId?: string;
  reportItemId?: string;
  roomId?: string;
  componentId?: string;
  inspectionId?: string;
  context?: {
    propertyAddress?: string;
    roomOrArea?: string;
    componentName?: string;
    inspectionType?: string;
  };
}

export const voiceApi = {
  analyze: async (params: VoiceAnalyzeParams) => {
    return apiClient.post<ApiResponse<VoiceAnalysis>>('/voice/analyze', params);
  },
};
